"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canUseEventBridge = exports.getEventBridge = void 0;
var __1 = require("..");
function getEventBridge() {
    var eventBridgeGlobal = getEventBridgeGlobal();
    if (!eventBridgeGlobal) {
        return;
    }
    return {
        getAllowedWebViewHosts: function () {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send: function (eventType, event) {
            eventBridgeGlobal.send(JSON.stringify({ eventType: eventType, event: event }));
        },
    };
}
exports.getEventBridge = getEventBridge;
function canUseEventBridge(hostname) {
    var _a;
    if (hostname === void 0) { hostname = (_a = (0, __1.getGlobalObject)().location) === null || _a === void 0 ? void 0 : _a.hostname; }
    var bridge = getEventBridge();
    return (!!bridge &&
        bridge.getAllowedWebViewHosts().some(function (host) {
            var escapedHost = host.replace(/\./g, '\\.');
            var isDomainOrSubDomain = new RegExp("^(.+\\.)*".concat(escapedHost, "$"));
            return isDomainOrSubDomain.test(hostname);
        }));
}
exports.canUseEventBridge = canUseEventBridge;
function getEventBridgeGlobal() {
    return (0, __1.getGlobalObject)().DatadogEventBridge;
}
//# sourceMappingURL=eventBridge.js.map